import { useState, useEffect } from 'react';
import { Mutex, withTimeout } from 'async-mutex';
import { storeBankingEvents } from '../../../../services/truststartService';
import { runInverite } from '../../../../services/integrationsService';

const isInvalidOrigin = (origin) => (!/^https:\/\/(sandbox|live|i1|www)\.inverite\.com/i.test(origin));
const sendEventMutex = withTimeout(new Mutex(), 4000);

const atomicUpdateOfEvents = (setEvents, requestId, clientId) => (
  async () => {
    const events = await new Promise((resolve) => {
      setEvents((currentEvents) => {
        resolve(currentEvents);
        return [];
      });
    });
    await storeBankingEvents({
      events,
      requestId,
      clientId,
    });
  });

const safeStoreBankingEvents = async (setEvents, requestId, clientId) => {
  try {
    await sendEventMutex.runExclusive(atomicUpdateOfEvents(setEvents, requestId, clientId));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error storing banking events', error);
  }
};

const eventNameEquals = (data, type) => (data === type || data?.detail === type);

export default function useInveriteEvents(
  clientId,
  scoringRequestId,
  onComplete,
) {
  const [isListening, setIsListening] = useState(false);
  const [showSkipBanking, setShowSkipBanking] = useState(true);
  const [, setEvents] = useState([]);
  const [smartConsentSessionId] = useState(Date.now());

  useEffect(() => {
    const onCrossFrameMessageReceived = async (event) => {
      const { origin, data } = event;
      if (isInvalidOrigin(origin)) return;
      const { detail, guid: inveriteRequestId } = data;
      const isComplete = eventNameEquals(data, 'success');
      const isStart = eventNameEquals(data, 'start');
      const isChooseBank = eventNameEquals(data, 'choose_bank');
      // eslint-disable-next-line no-console
      console.log('Inverite event', {
        detail,
        inveriteRequestId,
        isComplete,
        isChooseBank,
        isStart,
      });
      setEvents((prevEvents) => [...prevEvents, {
        smartConsentSessionId,
        timestamp: Date.now(),
        detail,
        sessionDetails: {
          inveriteId: inveriteRequestId,
        },
        isComplete,
        provider: 'inverite',
        source: 'smartconsent',
        rawEvent: data,
      }]);
      await safeStoreBankingEvents(setEvents, scoringRequestId, clientId);
      if (isStart) {
        setShowSkipBanking(false);
        await runInverite(scoringRequestId, clientId, { inveriteRequestId, detail, isComplete });
      }
      if (isChooseBank) {
        setShowSkipBanking(true);
      }
      if (!isComplete) return;
      onComplete();
    };
    window.addEventListener('message', onCrossFrameMessageReceived);
    setIsListening(true);
    return () => {
      window.removeEventListener('message', onCrossFrameMessageReceived);
    };
  }, [clientId, scoringRequestId, smartConsentSessionId, onComplete, setShowSkipBanking, setEvents]);
  return { isListening, showSkipBanking };
}
